
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const CaretForwardIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M69.196 42.3948C72.9334 45.1994 72.9333 50.8005 69.196 53.6051L41.2356 74.5877C36.622 78.0499 29.999 74.7794 29.999 68.9825L29.999 27.0174C29.999 21.2206 36.622 17.95 41.2356 21.4123L69.196 42.3948ZM36.999 27L36.999 69L65 48L36.999 27Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M67.0952 45.1943C68.9669 46.5989 68.9669 49.4012 67.0952 50.8057L39.1349 71.7883C36.8151 73.5291 33.499 71.8782 33.499 68.9825L33.499 27.0175C33.499 24.1218 36.8151 22.4709 39.1349 24.2117L67.0952 45.1943Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M26.802 42.3948C23.0647 45.1994 23.0647 50.8005 26.802 53.6051L54.7624 74.5877C59.3761 78.0499 65.999 74.7794 65.999 68.9825V27.0174C65.999 21.2206 59.3761 17.95 54.7624 21.4123L26.802 42.3948ZM58.999 27V69L30.998 48L58.999 27Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28.9028 45.1943C27.0311 46.5989 27.0311 49.4012 28.9028 50.8057L56.8632 71.7883C59.1829 73.5291 62.499 71.8782 62.499 68.9825V27.0175C62.499 24.1218 59.1829 22.4709 56.8632 24.2117L28.9028 45.1943Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
